import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SafeHtml } from "@angular/platform-browser";
import { Observable } from "rxjs";

import { Setting } from "../models/setting.model";

@Injectable({
	providedIn: "root",
})
export class SettingsService {
	private httpOptions = {
		responseType: "text",
	} as const;

	constructor(private http: HttpClient) {}

	public getSettings(companyId: string, endpoint: string): Observable<Setting[]> {
		return this.http.get<Setting[]>(`${endpoint}/settings?companyId=${companyId}&active=true`);
	}

	public patchSettings(payload: Setting, endpoint: string): Observable<Setting> {
		return this.http.patch<Setting>(`${endpoint}/settings`, payload);
	}

	public getAssetTypeImage(companyId: string, assetViewId: string, endpoint: string): Observable<SafeHtml> {
		return this.http.get(`${endpoint}/assets/views/${assetViewId}?companyId=${companyId}`, this.httpOptions);
	}
}
